let id = 1;
function getCRUDActions() {
  return { INDEX: id++, CREATE: id++, UPDATE: id++, DELETE: id++ };
}
function getFeedbackActions() {
  return { INDEX: id++, SEND: id++ };
}
/**
 * When adding new actions in between existing actions in future, do not use id++ !!!.
 * Instead use the id from the database.
 */
const vendorActions = {
  DEALERS: { ...getCRUDActions(), UPDATE_2: 160 },
  PROPOSALS: getCRUDActions(),
  ORDERS: {
    ...getCRUDActions(),
    SEND_INVOICE: id++,
    CHANGE_ITEMS: id++ // 'For 'Edit order' button
  },
  PAYMENTS: getCRUDActions(),
  RMA: { ...getCRUDActions(), COMPLETE: id++ },
  STYLES: getCRUDActions(), // This is for both series and collections
  MODIFICATIONS: getCRUDActions(),
  PARTS: getCRUDActions(),
  INVENTORY: {
    ITEMS: { INDEX: id++, UPDATE: id++ },
    PURCHASE_ORDERS: {
      ...getCRUDActions(),
      SEND: id++,
      RECEIVE_ITEMS: id++,
    },
    BARCODES: {
      INDEX: id++, DOWNLOAD: id++
    },
    SETTINGS: {
      INDEX: id++, UPDATE: id++,
    },
  },
  RESOURCES: getCRUDActions(),
  FEEDBACK: getFeedbackActions(),
  ANNOUNCEMENTS: getCRUDActions(),
  // New
  ACCOUNTING: {
    ACCOUNTS: {
      INDEX: 155,
      CREATE: 156,
      UPDATE: 157,
      DELETE: 158,
    },
  },
  EXPENSES: getCRUDActions(),
  REPORTS: {
    SALES_REP: { INDEX: id++ },
    PROFIT: { INDEX: id++ },
    SALES_ORDERS: { INDEX: id++, SEND: id++ },
    AGING: { INDEX: id++ },
    SALES_INVENTORY: { INDEX: id++ },
    INVENTORY: { INDEX: id++ },
    // New
    BALANCE: { INDEX: 154 },
  },
  SETTINGS: {
    GENERAL: { INDEX: id++, UPDATE: id++ },
    USERS: getCRUDActions(),
    SHIPPING: { INDEX: id++, UPDATE: id++ },
    ASSEMBLY: { INDEX: id++, UPDATE: id++ },
    TAXES: getCRUDActions(),
    EXPENSES: getCRUDActions(), // For both categories and vendors
    PERMISSIONS: getCRUDActions(),
    PAYMENTS: { INDEX: 162, UPDATE: 163 },
    AUDIT_LOGS: { INDEX: 165 },
  }
}

const showroomActions = {
  CUSTOMERS: getCRUDActions(),
  PROPOSALS: { ...getCRUDActions(), EMAIL: id++ },
  VISUAL_PROPOSALS: getCRUDActions(),
  CALENDAR: { INDEX: id++ },
  ORDERS: getCRUDActions(),
  RMA: { ...getCRUDActions(), SEND: id++ },
  RESOURCES: getCRUDActions(),
  FEEDBACK: getFeedbackActions(),
  REQUESTS: {
    NEW_MANUFACTURER: getCRUDActions(),
    PRICE_CHANGE: getCRUDActions(),
  },
  SETTINGS: {
    GENERAL: { INDEX: id++, UPDATE: id++ },
    MANUFACTURERS: { INDEX: id++, UPDATE: id++ },
    USERS: getCRUDActions(),
    TAXES: getCRUDActions(),
    VISUAL_PROPOSALS: getCRUDActions(),
    LOCATIONS: getCRUDActions(),
    INTEGRATIONS: {
      INDEX: 164,
    },
    PROMOTIONS: { INDEX: id++, UPDATE: id++ },
    PERMISSIONS: getCRUDActions(),
    AUDIT_LOGS: {
      INDEX: 159,
    },
  }
}

export const userGroupActions = {
  vendor: vendorActions,
  showroom: showroomActions
}
